import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Widget, GridView, SimpleView, Table, ColumnProps, FormResetButton, Row, FormInput, Form, Col, Button } from '@digital/ui';
import { PaginationConfig } from 'antd/lib/pagination';
import { FornecedorDefinicao, getAllFornecedor, updateFornecedor } from '../../api/fornecedor'
import { Input, Icon } from 'antd';
import { compareText, compareTypeNumber } from '@app/helpers/comparators';



const DefinicaoFornecedor = () => {

    const [allFornecedorDefinicao, setFornecedorDefinicao] = useState<FornecedorDefinicao[]>();
    const [editar, setEditar] = useState<boolean>(true);

    const colluns: ColumnProps<FornecedorDefinicao>[] = [
        {
            title: 'N',
            dataIndex: 'index',
            width: '3%',
            sorter: (a, b) => compareTypeNumber(a.index, b.index),
        },
        {
            title: 'Número',
            dataIndex: 'numero',
            sorter: (a, b) => compareTypeNumber(a.numero, b.numero),
            width: '3%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="numero"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numero !== undefined &&
                record.numero
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME MATRIZ - Pesquisa',
            dataIndex: 'nomeMatrizPesquisa',
            sorter: (a, b) => compareText(a.nomeMatrizPesquisa, b.nomeMatrizPesquisa),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nomeMatrizPesquisa"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nomeMatrizPesquisa !== undefined &&
                record.nomeMatrizPesquisa
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'CNPJ',
            dataIndex: 'cnpj',
            sorter: (a, b) => compareText(a.cnpj, b.cnpj),
            width: '5%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="cnpj"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.cnpj !== undefined &&
                record.cnpj
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME',
            dataIndex: 'nome',
            sorter: (a, b) => compareText(a.nome, b.nome),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nome"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nome !== undefined &&
                record.nome
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME RESUMIDO',
            dataIndex: 'nomeResumido',
            sorter: (a, b) => compareText(a.nomeResumido, b.nomeResumido),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nomeResumido"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nomeResumido !== undefined &&
                record.nomeResumido
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },

        {
            title: 'NOME MATRIZ',
            dataIndex: 'nomeMatriz',
            sorter: (a, b) => compareText(a.nomeMatriz, b.nomeMatriz),
            render: (index, record) => {
                return <>
                    <Input
                        value={record.nomeMatriz}
                        onChange={(e) => {
                            const novoValor = e.target.value;
                            record.nomeMatriz = novoValor;
                            record.itemEditado = true;
                            if (allFornecedorDefinicao) {
                                const itens = allFornecedorDefinicao.filter((fornecedor) => {
                                    if (fornecedor.id === record.id) {
                                        fornecedor = record;
                                    }
                                    return fornecedor;
                                });
                                setFornecedorDefinicao(itens);
                            }
                        }}
                        onPressEnter={() => {
                            harUpdate(record);
                        }}
                    />
                </>
            },
            width: '20%',

        }
    ]

    const codiguracaoPaginacao = {
        pageSize: 20,
        onChange: (() => {
            document.getElementById("tableResultDefinicaoFornecedor").scrollIntoView();
        })
    } as PaginationConfig;

    const harUpdate = (valores: FornecedorDefinicao) => {
        updateFornecedor(valores).then((data) => { });
    }

    useEffect(() => {
        getAllFornecedor().then((data) => {
            setFornecedorDefinicao(data);
        });
    }, [])


    return (
        <SimpleView >
            <GridView noform>
                {(true) ? (
                    <Widget
                        title="DEFINIÇÃO DOS FORNECEDORES"
                        span={12}
                        actions={[]}>
                        <Table
                            rowKey="id"
                            key="id"
                            id="tableResultDefinicaoFornecedor"
                            columns={colluns}
                            dataSource={allFornecedorDefinicao}
                            pagination={codiguracaoPaginacao}
                        />
                    </Widget>
                ) : (<> </>)}
            </GridView>
        </SimpleView>
    );
}
export default DefinicaoFornecedor;